/**
 * Organisation GUID for EmailPlatform APIs (EmailOutboundMessage / EmailInboundMessage scope).
 * Transactional sends (e.g. CAPA assignment) persist {@link capaModel.OrganizationId} into
 * `EmailOutboundMessage.OrganizationRefId`. Session objects may expose both `OrganizationId`
 * and `OrganizationRefId`; they can differ — prefer **OrganizationId** first so staff inbox
 * matches stored rows.
 *
 * @param {Record<string, unknown> | null | undefined} userData
 * @returns {string} Trimmed GUID string, or "" if none.
 */
export function resolveEmailPlatformOrganizationGuid(userData) {
  if (!userData) return "";
  const candidates = [
    userData.OrganizationId,
    userData.organizationId,
    userData.OrganizationRefId,
    userData.organizationRefId,
  ];
  const value = candidates.find((v) => String(v || "").trim());
  return String(value || "").trim();
}
